var _rect, _rect2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncertain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4271_5877",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#383A36"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4271_5877)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FC8E11"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4271_5877",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 13,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5875 11.8251C10.3208 11.8251 10.1187 11.7459 9.98123 11.5876C9.84373 11.4293 9.78331 11.2251 9.79998 10.9751C9.82498 10.6001 9.91456 10.2813 10.0687 10.0188C10.2229 9.75635 10.4666 9.50426 10.8 9.2626C11.125 9.00426 11.3666 8.7501 11.525 8.5001C11.6833 8.2501 11.7625 7.97438 11.7625 7.67294C11.7625 7.34938 11.6556 7.08135 11.4419 6.86885C11.2282 6.65635 10.9392 6.5501 10.575 6.5501C10.3 6.5501 10.065 6.59983 9.86989 6.6993C9.67483 6.79876 9.5057 6.94486 9.36248 7.1376C9.22915 7.30426 9.06873 7.40843 8.88123 7.4501C8.69373 7.49176 8.51545 7.47232 8.3464 7.39176C8.08212 7.27232 7.93956 7.07926 7.91873 6.8126C7.8979 6.54593 7.97498 6.30426 8.14998 6.0876C8.42498 5.74593 8.76421 5.4751 9.16767 5.2751C9.57112 5.0751 10.0402 4.9751 10.575 4.9751C11.4848 4.9751 12.1852 5.23419 12.6761 5.75236C13.167 6.27053 13.4125 6.90065 13.4125 7.64272C13.4125 8.13931 13.325 8.57718 13.15 8.95635C12.975 9.33551 12.6958 9.69176 12.3125 10.0251C12.0875 10.2251 11.9146 10.4063 11.7937 10.5688C11.6729 10.7313 11.5791 10.9168 11.5125 11.1251C11.4125 11.3418 11.2837 11.5126 11.1261 11.6376C10.9685 11.7626 10.7889 11.8251 10.5875 11.8251ZM10.5739 15.3501C10.2496 15.3501 9.97498 15.2372 9.74998 15.0115C9.52498 14.7858 9.41248 14.5149 9.41248 14.199C9.41248 13.8747 9.52535 13.6001 9.75109 13.3751C9.97683 13.1501 10.2518 13.0376 10.5761 13.0376C10.9004 13.0376 11.175 13.1505 11.4 13.3762C11.625 13.6019 11.7375 13.8769 11.7375 14.2012C11.7375 14.5171 11.6246 14.7876 11.3989 15.0126C11.1731 15.2376 10.8981 15.3501 10.5739 15.3501Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4271_5877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.5,
    y: -6.80005,
    width: 30.6,
    height: 33.6,
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4271_5877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncertain);
export default __webpack_public_path__ + "static/media/uncertain.441c8f2446c92201dfd72116b20c2f55.svg";
export { ForwardRef as ReactComponent };